<template>
    <div class="px-lg pb-xl md:px-[25px] lg:px-[75px]">
        <Icon name="swingu-logo" class="max-w-[98px]" />

        <div class="mt-xl text-sm lg:flex">
            <div class="">
                <div class="max-w-[350px] text-xl font-medium text-gray-800">
                    On-course tools and advanced stats trusted by golfers
                    everywhere
                </div>
                <div
                    class="mt-lg xs:flex lg:mt-xl [&>*]:block [&>*]:max-w-[50%]"
                >
                    <Icon name="apple-cta" width="188" height="55" />
                    <Icon
                        name="google-cta"
                        width="188"
                        height="55"
                        class="mt-2 xs:ml-2 xs:mt-0"
                    />
                </div>
            </div>
            <div
                class="max-w-1/3 ml-auto gap-2xl xs:flex [&_a:hover]:text-primary-600 [&_a:hover]:transition [&_a:hover]:duration-300"
            >
                <div class="lg:pl-lg">
                    <div
                        class="mt-2xl text-xs font-semibold text-gray-600 lg:mt-0"
                    >
                        SwingU
                    </div>
                    <ul
                        class="mt-md text-lg font-medium text-gray-800 [&>li]:mb-md"
                    >
                        <li>
                            <a href="//swingu.com">Home</a>
                        </li>
                        <li>
                            <a href="//swingu.com/about">Our Team</a>
                        </li>
                    </ul>
                </div>
                <div>
                    <div
                        class="mt-2xl text-xs font-semibold text-gray-600 lg:mt-0"
                    >
                        SwingU Network
                    </div>
                    <ul
                        class="mt-md text-lg font-medium text-gray-800 [&>li]:mb-md"
                    >
                        <li>
                            <a href="//swingu.com/coach">Coaches</a>
                        </li>
                        <li>
                            <a href="//clubhouse.swingu.com">Clubhouse</a>
                        </li>
                        <li>
                            <a href="//courses.swingu.com">Courses</a>
                        </li>
                        <li>
                            <a href="//swingu.com/marketing">Marketing</a>
                        </li>
                        <li>
                            <a href="//clubhouse.swingu.com/press">Press</a>
                        </li>
                    </ul>
                </div>
                <div>
                    <div
                        class="mt-2xl text-xs font-semibold text-gray-600 lg:mt-0"
                    >
                        Help
                    </div>
                    <ul
                        class="mt-md text-lg font-medium text-gray-800 [&>li]:mb-md"
                    >
                        <li>
                            <a href="//help.swingu.com">Support</a>
                        </li>
                        <li>
                            <a href="//swingu.com/privacy-policy">
                                Privacy Policy
                            </a>
                        </li>
                        <li>
                            <a href="//swingu.com/terms-of-service">
                                Terms of Use
                            </a>
                        </li>
                        <li>
                            <a href="mailto:support@swingu.com" target="_blank">
                                Contact
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="mt-2xl text-[11px] text-gray-600 lg:mt-4xl lg:flex">
            <div>
                <div>
                    © {{ new Date().getFullYear() }} Swing by Swing Golf, LLC,
                    All Rights Reserved.
                </div>
            </div>

            <div class="mt-xl flex xs:ml-auto lg:mt-0">
                <div class="mr-auto flex items-center gap-lg lg:ml-auto">
                    <Icon
                        name="social-x"
                        width="20"
                        height="20"
                        class="ml-auto text-gray-800"
                    />
                    <Icon
                        name="social-instagram"
                        width="20"
                        height="21"
                        class="ml-auto text-gray-800"
                    />
                    <Icon
                        name="social-facebook"
                        width="20"
                        height="20"
                        class="ml-auto text-gray-800"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script setup></script>
